const cssVariables = {
  color: {
    primary: "#5DA196",
    black: "#404349",
    white: "#FFF",
    red: "#BD4B53",
    gray: "#F5F5F5",
    blue: "#5387C6"
  },
  barChart: {
    blue: {
      100: "#336199",
      200: "#5387C6",
      300: "#8CAFD9",
    },
    orange: {
      100: "#FC9A3E",
      200: "#FFC58C",
      300: "#FC9A3E",
    },
    green: {
      200: "#BAD957",
    },
    purple: {
      100: "#424C8A",
      200: "#6470B4",
      300: "#989FCD",
    },
    planningTable: {
      100: "#4085C9",
      200: "#BAD957",
      300: "#FC9A3E",
      400: "#FFC58C",
      500: "#5387C6",
    },
    donutHomeKpi: {
      100: "#F8B620",
      200: "#F28E2B",
      300: "#5DA196",
    },
    evaluationRatio: {
      100: "#FA9349",
      200: "#74C1ED",
    },
    totalAchievements: {
      100: "#FA9349",
      200: "#74C1ED",
      300: "#F7B254",
      400: "#31B09B",
    },
  }
};

export default cssVariables